import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { NavbarService } from '../../core/navbar.service';
import { SeoService } from '../../core/seo.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  contactForm: FormGroup;
  loading: boolean = false;
  success: boolean = false;

  submittedData = {
    name: '',
    email: '',
    subject: '',
    message: ''
  };

  get name() {
    return this.contactForm.get('name');
  }

  get email() {
    return this.contactForm.get('email');
  }

  get subject() {
    return this.contactForm.get('subject');
  }

  get message() {
    return this.contactForm.get('message');
  }

  get mailtoLink(): string {
    const contactName = this.submittedData.name || this.contactForm?.value?.name || '';
    const contactEmail = this.submittedData.email || this.contactForm?.value?.email || '';
    const contactSubject = this.submittedData.subject || this.contactForm?.value?.subject || 'Museum Inquiry';
    const contactMsg = this.submittedData.message || this.contactForm?.value?.message || '';

    const subject = encodeURIComponent(`Website Message: ${contactSubject} (from ${contactName})`);
    const body = encodeURIComponent(
      `Hello Bayou Lacombe Museum Team,\n\nI am sending this message from the website:\n\nName: ${contactName}\nEmail: ${contactEmail}\nSubject: ${contactSubject}\n\nMessage:\n${contactMsg}\n\nThank you,\n${contactName}`
    );
    return `mailto:bayoulacombemuseum@gmail.com,info@bayoulacombemuseum.com?subject=${subject}&body=${body}`;
  }

  constructor(
    private fb: FormBuilder,
    private afs: AngularFirestore,
    public nav: NavbarService,
    private seo: SeoService
  ) { }

  ngOnInit() {
    this.nav.show();
    this.seo.updateTags({
      title: 'Contact & Directions',
      description: 'Find hours, location map, and contact information for Bayou Lacombe Museum in St. Tammany Parish, Louisiana. 61115 S St. Mary Street, Lacombe, LA 70445.',
      url: '/contact'
    });

    this.contactForm = this.fb.group({
      name: ['', [Validators.required, Validators.pattern('[a-zA-Z .-]*')]],
      email: ['', [Validators.required, Validators.email]],
      subject: ['', [Validators.required]],
      message: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  async onSubmit() {
    if (this.contactForm.invalid) return;

    this.loading = true;
    const formValue = {
      name: this.contactForm.value.name,
      email: this.contactForm.value.email,
      subject: this.contactForm.value.subject,
      message: this.contactForm.value.message,
      createdAt: new Date()
    };

    this.submittedData = {
      name: this.contactForm.value.name,
      email: this.contactForm.value.email,
      subject: this.contactForm.value.subject,
      message: this.contactForm.value.message
    };

    try {
      // Trigger newContact Cloud Function via Firestore write
      await this.afs.collection('contact').add(formValue);
      this.success = true;
    } catch (err) {
      console.error('Firestore contact save note:', err);
      this.success = true;
    } finally {
      this.loading = false;
    }
  }
}
